
export class User{
    appUserId:number;
    FirstName:string;
    LastName:string;
    cityID : number;  
    EmailId:string;
    officeID:Array<number>=[];
    //Officeid:number;
    isActive:boolean;
    IsRequestor:boolean;
    IsApprover:boolean;
    RoleID:number;
    addedBy: string;
    changedBy: string;
    dateAdded:Date;
    dateChanged:Date;
    isL1: boolean;
    isL2: boolean;
    practiceID: number;
    
}
